import { render, staticRenderFns } from "./DeviceRelationSelectList.vue?vue&type=template&id=5b94202a&scoped=true&"
import script from "./DeviceRelationSelectList.vue?vue&type=script&lang=ts&"
export * from "./DeviceRelationSelectList.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceRelationSelectList.vue?vue&type=style&index=0&id=5b94202a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b94202a",
  null
  
)

export default component.exports